import { create } from 'zustand';

import type { EditStore } from '../types/edit-store';

export const useEditStore = create<EditStore>((set) => ({
  isEditing: false,
  setIsEditing: (isEditing: boolean) => {
    set({ isEditing });
  },
}));
